import React, { useState } from 'react';

const TabHeader: React.FC<{
  list: { key: string; text: string }[];
  defaultValue?: string;
  onChange?: (key: string) => void;
  classNames?: { wrap?: string; item?: string };
}> = ({ list, defaultValue, onChange, classNames = {} }) => {
  const [active, setActive] = useState(defaultValue || list[0]?.key);
  const handleClick = (key: string) => {
    setActive(key);
    if (onChange) onChange(key);
  };

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-gray-50 p-[6px] sm:w-full ${
        classNames.wrap || ''
      }`}
    >
      {list.map((item) => (
        <p
          aria-expanded={item.key === active}
          key={item.key}
          className={`relative cursor-pointer rounded-full bg-transparent p-[10px] text-center text-14 font-semibold text-gray-500 duration-300 aria-expanded:bg-white aria-expanded:text-black sm:!text-[12px] ${
            classNames.item || ''
          }`}
          onClick={() => handleClick(item.key)}
        >
          {item.text}
        </p>
      ))}
    </div>
  );
};

export default TabHeader;
